<template>
    <div class="AllLayers">
        <Layer class="layer" v-for="stijl in mapStyles" :key="stijl.titel" :stijl="stijl"/>
    </div>
</template>
<style scoped>
    .AllLayers{
        display: flex;  
        flex-direction: column; 
    }
    .layer{
        width: auto;
        height: 40px;
    }

    
</style>
<script>
import Layer from "../components/Layer.vue"

export default {
    name: "AllLayers",
    components:{
        Layer
    },
    computed: {
        mapStyles() {
            return this.$store.state.map.mapStyles
        }
  }

}
</script>

